<template>
  <div class="can-invoicing-orders">
    <div class="table-header">
      <div class="table-row check-box">
        <el-checkbox
          :value="checkAllOrders"
          size="mini"
          class="check-field"
          @change="changeAllSelect($event)"
        ></el-checkbox>
      </div>
      <div class="table-row order-id-row">订单号</div>
      <div class="table-row order-product-name">商品名称</div>
      <div class="table-row applicant-names">出行人</div>
      <div class="table-row order-pay-date">支付时间</div>
      <div class="table-row order-price">
        <div class="top-row-title">订单金额</div>
        <div class="bottom-row-sub-title">（不含退款）</div>
      </div>
    </div>
    <div class="table-content-wrapper">
      <div class="table-content">
        <div
          class="table-col"
          :class="{ selected: order.is_selected }"
          v-for="order in invoicingOrders"
          :key="order.id"
          @click="changeSelect({ target: { checked: !order.is_selected } }, order)"
        >
          <div class="table-row check-box" @click.stop="() => {}">
            <el-checkbox
              :value="order.is_selected"
              size="mini"
              class="check-field"
              @change="changeSelect($event, order)"
            ></el-checkbox>
          </div>
          <div class="table-row order-id-row">{{ order.id }}</div>
          <div class="table-row order-product-name">{{ order.product_name }}</div>
          <div class="table-row applicant-names">{{ order.applicant_names }}</div>
          <div class="table-row order-pay-date">{{ order.pay_time.substring(0, 16) }}</div>
          <div class="table-row order-price">￥{{ (order.invoice_price / 100).toFixed(2) }}</div>
        </div>
      </div>
    </div>
    <div class="table-footer">
      <div class="simple-text">已选:</div>
      <div class="red-text">{{ selectedOrders.length }}</div>
      <div class="simple-text">个订单</div>
      <div class="simple-text next-p">合计可开</div>
      <div class="blue-text">{{ (totalOrderPrice / 100).toFixed(2) }}</div>
      <div class="simple-text">元</div>
    </div>
  </div>
</template>

<script>
import utils from '../../../libs/utils';

export default {
  name: 'can-invoicing-orders',
  props: {
    invoicingOrders: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    selectedOrders: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    totalOrderPrice: {
      type: Number,
      required: true,
      default: 0,
    },
    checkAllOrders: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {

    // 切换单个订单选中与否
    changeSelect($event, order) {
      if ($event.stopPropagation) {

        // IE
        $event.stopPropagation();
        const isSelected = utils.isIE() ? !$event.target.checked : $event.target.checked;
        this.$emit('changeSelectedOrders', {
          checked: isSelected,
          order,
        });
      } else {

        // 其他
        const isSelected = $event.target.checked;
        this.$emit('changeSelectedOrders', {
          checked: isSelected,
          order,
        });
      }
    },

    // 切换全选
    changeAllSelect($event) {
      const isSelected = $event.target.checked;
      this.$emit('changeAllSelect', {
        checked: isSelected,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.can-invoicing-orders {
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eef2;
  margin-top: 16px;
  width: 100%;
  .table-header {
    width: 100%;
    display: flex;
    align-items: center;
    height: 44px;
    background: #fafbfc;
    border-bottom: 1px solid #e9eef2;
    .table-row {
      font-weight: 500;
      &.order-price {
        display: flex;
        flex-direction: column;
        align-items: center;
        .top-row-title {
          margin-bottom: 4px;
        }
        .bottom-row-sub-title {
          color: #5F666E;
          font-weight: normal;
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
  }
  .table-content-wrapper {
    overflow-y: auto;
    max-height: 317px;
    width: 100%;
    .table-content {
      .table-col {
        cursor: pointer;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e9eef2;
        &:hover,
        &.selected {
          background-color: rgba(89, 159, 255, 0.06);
        }
        &:last-child {
          border-bottom: 0;
        }
        .table-row {
          height: 48px;
          font-weight: 400;
        }
      }
    }
  }
  .table-footer {
    width: 100%;
    height: 60px;
    background: #ffffff;
    border-top: 1px solid #e9eef2;
    padding: 0 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #2f333d;
    line-height: 20px;
    .simple-text {
      color: #2F333D;
    }
    .red-text {
      color: #FF8033;
      margin: 0 5px;
    }
    .next-p {
      margin-left: 12px;
    }
    .blue-text {
      color: #599FFF;
      margin: 0 5px;
    }
  }
  .table-row {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #2f333d;
    line-height: 14px;
    &.check-box {
      width: 44px;
      justify-content: center;
    }
    &.order-id-row {
      width: 90px;
    }
    &.order-product-name {
      width: 450px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 20px;
      display: block;
      line-height: 48px;
    }
    &.applicant-names {
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 20px;
      display: block;
      line-height: 48px;
    }
    &.order-pay-date {
      width: 130px;
    }
    &.order-price {
      flex: 1;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/can-invoicing-orders.vue